"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = clickguard;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _reactMintl = require("@godaddy/react-mintl");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = _interopRequireDefault(require("./"));
var modal = _interopRequireWildcard(require("./modal"));
var _button = _interopRequireDefault(require("@ux/button"));
var _modal2 = _interopRequireDefault(require("@ux/modal"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * ClickGuard modal.
 *
 * @class Title
 * @api private
 */
class ClickGuard extends _react.Component {
  /**
   * Event handler for cancel or continue button. This will always close the modal,
   * but the original guarded action could still be performed.
   *
   * @param {Boolean} allow Should callback be called
   * @returns {Function} event handler
   * @api private
   */
  close(allow) {
    const props = this.props;
    return () => {
      this.ref.close();

      //
      // Continue button was clicked, call the supplied callback.
      //
      if (allow) {
        props.callback(props.event);
      }
    };
  }

  /**
   * Modal title, fallback to default.
   *
   * @returns {React.ReactElement} title
   * @api private
   */
  get title() {
    return this.props.title || /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:AccountDelegation:deny-all-title"
    });
  }

  /**
   * Modal footer buttons.
   *
   * @returns {React.ReactElement[]} both cancel and continue button
   * @api private
   */
  get footer() {
    return [/*#__PURE__*/_react.default.createElement(_button.default, {
      key: "cancel",
      onClick: this.close(),
      text: /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: "Shared:AccountDelegation:cancel"
      })
    }), /*#__PURE__*/_react.default.createElement(_button.default, {
      key: "continue",
      onClick: this.close(true),
      text: this.props.caption || /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: "Shared:AccountDelegation:continue"
      })
    })];
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_modal2.default, {
      ref: c => {
        this.ref = c;
      },
      title: this.title,
      id: "click-guard-modal",
      footer: this.footer
    }, this.props.message || /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:AccountDelegation:deny-all-msg"
    }));
  }
}

/**
 * Custom clickguard modal properties.
 *
 * @enum {Object}
 * @api public
 */
ClickGuard.propTypes = {
  /** modal text contents */
  message: _propTypes.default.string,
  /** text for the continue button */
  caption: _propTypes.default.string,
  /** title for the modal */
  title: _propTypes.default.string,
  /** called when the continue button was clicked */
  callback: _propTypes.default.func,
  /** event passed as argument to callback */
  event: _propTypes.default.any
};

/**
 * Setup event listener to intercept events when account delegation is active.
 *
 * @param {Object} messages Internationalized strings.
 * @param {Object} props Additional properties required for customized modal
 * @param {Function} done Completion callback
 * @returns {Function} Event listener
 * @api private
 */
function clickguard(messages) {
  let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let done = arguments.length > 2 ? arguments[2] : undefined;
  if (typeof props === 'function') {
    done = props;
    props = {};
  }
  return function handle(event) {
    if (!_.default.active) {
      return done(event);
    }
    modal.render( /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      messages: messages
    }, /*#__PURE__*/_react.default.createElement(ClickGuard, (0, _extends2.default)({}, props, {
      event: event,
      callback: done
    }))));
  };
}